import React from 'react';
import { inject } from 'mobx-react';
import { UnauthorizedTemplate } from 'themes/modules/membership/pages';

@inject(i => ({
	routerStore: i.rootStore.routerStore,
}))
class Unauthorized extends React.Component {
	render() {
		return <UnauthorizedTemplate {...this.props} />;
	}
}

export default Unauthorized;
